/** Pure barrel — re-exports only side-effect-free modules */
export * from "./EXT_mesh_gpu_instancing.pure";
export * from "./KHR_draco_mesh_compression.pure";
export * from "./KHR_lights_punctual.pure";
export * from "./EXT_lights_area.pure";
export * from "./KHR_materials_anisotropy.pure";
export * from "./KHR_materials_clearcoat.pure";
export * from "./KHR_materials_coat.pure";
export * from "./KHR_materials_diffuse_transmission.pure";
export * from "./KHR_materials_dispersion.pure";
export * from "./KHR_materials_emissive_strength.pure";
export * from "./KHR_materials_ior.pure";
export * from "./KHR_materials_iridescence.pure";
export * from "./KHR_materials_sheen.pure";
export * from "./KHR_materials_fuzz.pure";
export * from "./KHR_materials_specular.pure";
export * from "./KHR_materials_transmission.pure";
export * from "./KHR_materials_unlit.pure";
export * from "./KHR_materials_volume.pure";
export * from "./KHR_materials_volume_scatter.pure";
export * from "./KHR_materials_diffuse_roughness.pure";
export * from "./KHR_materials_openpbr.pure";
export * from "./KHR_texture_transform.pure";
export * from "./KHR_texture_basisu.pure";
export * from "./EXT_texture_webp.pure";
export * from "./EXT_texture_avif.pure";
